/* ============================================================================
   bt-ratgeber.js  ·  Inhaltsverzeichnis, Fortschritt und Tabellen fuer BT-R01.
   Die interaktiven Tools liegen in bt-minitools.js, der Kern in
   bt-ratgeber-calc.js.

   OEFFNUNGSZEITEN: stehen NICHT mehr hier. Diese Datei hatte bis zum
   31.08.2026 eine eigene Berechnung neben dem zentralen Snippet
   snippets/bt-hours.liquid, also zwei Quellen fuer dieselbe Aussage
   (Task C8). Die Rechnung liegt jetzt ausschliesslich im Snippet, das
   BT-R01 selbst rendert. Es steuert weiterhin data-bt-hours, is-open,
   data-bt-status und data-bt-next, dazu wie bisher data-bt-hours-phone
   und data-bt-hours-closed.
   ========================================================================== */
(function(){
  'use strict';

  var BT = window.BTModul = window.BTModul || { reg: {} };

  var root = document.querySelector('[data-bt-ratgeber]');
  if(!root) return;

  var main   = root.querySelector('.bt-article__main');
  var nav    = root.querySelector('[data-bt-toc]');
  var toggle = root.querySelector('.bt-toc-toggle');
  var wrap   = root.querySelector('.bt-toc-collapse');

  /* ---- Tabellen scrollbar machen -------------------------------------------
     Frueher lief das ueber display:block auf der Tabelle selbst. Damit werden
     thead und tbody zu getrennten Tabellen, border-collapse greift nicht mehr
     ueber die Grenze, und Linien wie Zellhoehen weichen vom Design-System ab.
     Deshalb bekommt jede Tabelle hier einen echten Rahmen umgehaengt und bleibt
     selbst unveraendert. */
  if(main){
    Array.prototype.forEach.call(main.querySelectorAll('table'), function(t){
      if(t.parentNode && t.parentNode.classList.contains('bt-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'bt-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  /* ---- Video im Artikeltext ------------------------------------------------
     Der YouTube-Rahmen wird ERST BEIM KLICK eingehaengt. Vorher geht keine
     Verbindung zu Google raus. Aus demselben Grund steht als Platzhalter die
     Navy-Flaeche aus dem Design-System und nicht das YouTube-Vorschaubild,
     denn auch das laege auf einem Google-Server.

     Markup gehoert in den ARTIKELTEXT, nicht ins Template, weil ein Template
     fuer alle Ratgeber gilt. Nur im HTML-Modus des Editors einfuegen:
       <div class="bt-video">
         <div class="bt-video__player" data-bt-video="VIDEO-ID" data-bt-video-titel="Titel">
           <div class="bt-video__play-circle"><div class="bt-video__play"></div></div>
           <div class="bt-video__label">Beschriftung</div>
         </div>
         <div>Begleittext</div>
       </div>
     VIDEO-ID ist der Teil hinter watch?v= in der YouTube-Adresse. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-bt-video]'), function(el){
    var id = el.getAttribute('data-bt-video');
    if(!id || el.getAttribute('data-bt-video-ready')) return;
    el.setAttribute('data-bt-video-ready', '1');

    var titel = el.getAttribute('data-bt-video-titel') || (window.btT ? window.btT('bt_ratgeber.play_video', 'Video abspielen') : 'Video abspielen');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', titel);
    el.style.cursor = 'pointer';

    function start(){
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      f.title = titel;
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;z-index:2;';
      el.innerHTML = '';
      el.appendChild(f);
    }

    el.addEventListener('click', start);
    el.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); start(); }
    });
  });

  /* ---- Inhaltsverzeichnis --------------------------------------------------
     Quelle sind die H2 der Textbloecke UND die Kopfzeilen der Tools, denn ein
     Tool ist ein eigenes Kapitel. Ueberschriften in CTA- und Beratungsboxen
     sind keine Kapitel und bleiben draussen. */
  var heads = [];
  if(main){
    Array.prototype.forEach.call(main.querySelectorAll('.bt-c01 h2'), function(h){
      if(h.closest('.bt-cta') || h.closest('.bt-beratung')) return;
      heads.push(h);
    });
  }

  function slug(t){
    return t.toLowerCase()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
      .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,60);
  }

  var items = [];
  if(nav && heads.length >= 3){
    heads.forEach(function(h, i){
      if(!h.id) h.id = 'kapitel-' + (i+1) + '-' + slug(h.textContent || '');
      h.classList.add('bt-anchor-offset');
      var a = document.createElement('a');
      a.className = 'bt-toc-vert__item';
      a.href = '#' + h.id;
      a.textContent = (h.textContent || '').trim();
      nav.appendChild(a);
      items.push(a);
    });
    nav.classList.add('bt-toc-vert');
    if(toggle) toggle.hidden = false;
    if(wrap) wrap.hidden = false;
  } else if(wrap){
    wrap.remove();
    if(toggle) toggle.remove();
  }

  if(toggle && wrap){
    toggle.addEventListener('click', function(){
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      wrap.classList.toggle('is-open', !open);
    });
    items.forEach(function(a){
      a.addEventListener('click', function(){
        if(window.innerWidth <= 1020){
          toggle.setAttribute('aria-expanded', 'false');
          wrap.classList.remove('is-open');
        }
      });
    });
  }

  /* ---- Aktives Kapitel und Fortschrittsschiene -----------------------------
     Beides folgt der KAPITELPOSITION, nicht der Scrolltiefe. Ein bildlastiges
     Kapitel frisst viel Scrolltiefe, belegt in der Liste aber nur eine Zeile.
     Markierung und Schiene speisen sich deshalb aus derselben Rechnung. */
  var ticking = false;
  var timer = null;

  function currentIndex(){
    var y = window.pageYOffset + (window.innerHeight * 0.28);
    var idx = 0;
    for(var i = 0; i < heads.length; i++){
      if(heads[i].getBoundingClientRect().top + window.pageYOffset <= y) idx = i;
    }
    return idx;
  }

  function paint(){
    if(!items.length) return;
    var idx = currentIndex();
    items.forEach(function(a, i){ a.classList.toggle('is-active', i === idx); });
    if(nav) nav.style.setProperty('--bt-rail-s', ((idx + 1) / items.length).toFixed(4));
  }

  function onScroll(){
    if(ticking) return;
    ticking = true;
    /* Sperre faellt am ANFANG des Callbacks. Feuert rAF in einem inaktiven Tab
       nicht, bliebe der Handler sonst dauerhaft gesperrt. Timer als zweite
       Sicherung genau dafuer. */
    window.requestAnimationFrame(function(){ ticking = false; paint(); });
    clearTimeout(timer);
    timer = setTimeout(function(){ ticking = false; paint(); }, 250);
  }

  if(items.length){
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    paint();
  }

  if(document.querySelector('.bt-callbar')) document.body.classList.add('has-callbar');
})();
